export default (type = "", displayDelayVideos = 30, displayDelayArticles = 30, displayFrequency = 2, displayMaxAmount = 3, expireCookieCloseButton = 3, expireCookieCtaButton = 7, yearlyDonationUrl = "", monthlyDonationUrl = "", manualDonationUrl = "") => ({

    type: type,
    showPopover: false,
    closedPopover: false,
    pageCounterValue: null,
    displayDelayVideos: (displayDelayVideos * 1000),
    displayDelayArticles: (displayDelayArticles * 1000),
    displayFrequency: displayFrequency,
    displayMaxAmount: displayMaxAmount,
    expireCookieCloseButton: expireCookieCloseButton,
    expireCookieCtaButton: expireCookieCtaButton,
    yearlyDonationUrl: yearlyDonationUrl,
    monthlyDonationUrl: monthlyDonationUrl,
    manualDonationUrl: manualDonationUrl,
    cookieVisibilityName: "popOver-hidden-v1",
    cookiePageCounterName: "popOver-counter-v1",
    subscriptionType: "monthly",
    subscriptionAmount: "5",

    init () {
        this.incrementPageCounter();
        if(this.type == 'article' && this.checkIfPopoverCanBeShown()) {
            this.showOnArticleSettings();
        }
    },

    showOnVideo () {
        if(this.type == 'video' && this.checkIfPopoverCanBeShown()){
            setTimeout(() => this.openPopover(), this.displayDelayVideos)
        }
    },

    showOnArticleSettings () {
        window.onscroll = (e) => {
            if(!this.closedPopover) {
                setTimeout(() => this.openPopover(), this.displayDelayArticles)
            }
        }
    },

    openPopover () {
        if (!this.closedPopover) {
            this.showPopover = true;
        }
    },

    closePopover () {
        this.showPopover = false;
        this.closedPopover = true;
        this.setCookieHidden(true, parseInt(this.expireCookieCloseButton));
        this.fireAnalyticsEvent('pop-over donations closed', this.subscriptionType);
    },

    clickCtaButton (url) {
        this.setCookieHidden(true, parseInt(this.expireCookieCtaButton));
        this.openSubscriptionUrl();
        this.showPopover = false;
        this.closedPopover = true;
        this.fireAnalyticsEvent('pop-over donations', this.subscriptionType);
    },

    openSubscriptionUrl() {
        switch(this.subscriptionType) {
            case 'yearly':
                window.open(this.yearlyDonationUrl + Math.round(this.subscriptionAmount.replace('.','')), "_blank").focus();
                break;
            case 'monthly':
                window.open(this.monthlyDonationUrl + Math.round(this.subscriptionAmount.replace('.','')), "_blank").focus();
                break;
            case 'manual':
                window.open(this.manualDonationUrl, "_blank").focus();
                break;
        }
    },

    checkIfPopoverCanBeShown () {
        let cookieVal = this.getCookie(this.cookieVisibilityName)

        if(this.pageCounterValue > (this.displayMaxAmount * this.displayFrequency))  {
            return false;
        }

        // Show because cookie isn't set.
        if (cookieVal == null && (this.pageCounterValue % this.displayFrequency == 0)) {
            return true
        }

        // hide because cookie is set
        return false;
    },

    fireAnalyticsEvent (name, subscriptionType = null) {
        let typeSetting = (this.type === 'article' ? this.displayDelayArticles : this.displayDelayVideos);
        let popoverSettings =  '(p' + this.pageCounterValue + ' f' + this.displayFrequency + ' d' + typeSetting + ')';

        gtag('event', name, {
          'event_category': 'popover',
          'event_label': subscriptionType,
          'value': popoverSettings
        });
    },

    setCookieHidden (hide, days) {
        this.setCookie(this.cookieVisibilityName, hide, days)
    },

    incrementPageCounter () {
        this.pageCounterValue = this.getCookie(this.cookiePageCounterName);
        if(this.pageCounterValue == null){
            this.pageCounterValue = '1';
        } else {
            this.pageCounterValue = parseInt(this.pageCounterValue) + 1;
        }
        this.setCookie(this.cookiePageCounterName, this.pageCounterValue, 0)
    },

    setCookie (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + ";path=/;SameSite=Strict";
    },

    getCookie (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },

})
